import { z } from 'zod';

export const placeSchema = z.object({
    place_id: z.number(),
    city: z.string().nullable(),
    countryCode: z.string().nullable(),
    postalCode: z.string().nullable(),
    latitude: z.coerce.number().nullable(),
    longitude: z.coerce.number().nullable(),
    note: z.string().nullable(),
    directionLoading: z.boolean().default(false),
    directionDischarge: z.boolean().default(false),
    deleted: z.boolean().default(false),
    dispatcher_id: z.number().nullable(),
    carrier_id: z.number().nullable(),
});
export type TPlace = z.infer<typeof placeSchema>;
